module.exports = __webpack_public_path__ + "img/4d8b636.jpg";